<template>
    <div
        class="timeline-section"
        :class="{ pause: interval.type === 'pause' }"
        :style="'width: ' + width + '%'">
        <span
            v-if="overtime"
            class="overtime"
            :style="'width: ' + overtime + '%'"></span>
        <div class="popup">
            <p class="line">
                Start:
                <span class="bold">{{ interval.start.format('HH:mm') }}</span>
            </p>
            <p class="line">
                Einde:
                <span class="bold">{{ interval.end.format('HH:mm') }}</span>
            </p>
            <p class="line">
                Totaal:
                <span class="bold">{{ totalDurationFormatted }}</span>
            </p>
            <p class="line" v-if="interval.idealMinutes">
                Ideale werktijd:
                <span class="bold">{{ interval.idealMinutes + ' min' }}</span>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        interval: {
            type: Object,
            required: true,
        },
        width: {
            type: Number,
            required: true,
        },
    },
    computed: {
        overtime() {
            if (!this.interval.idealMinutes) {
                return;
            }

            return 100 - this.idealWidth(this.interval);
        },
        totalDuration() {
            return this.interval.end.diff(this.interval.start, 'seconds');
        },
        totalDurationFormatted() {
            const totalInMinutes = this.interval.end.diff(
                this.interval.start,
                'minutes'
            );

            const hours =
                Math.floor(totalInMinutes / 60) < 10
                    ? '0' + Math.floor(totalInMinutes / 60)
                    : Math.floor(totalInMinutes / 60);
            const seconds =
                Math.floor(totalInMinutes % 60) < 10
                    ? '0' + Math.floor(totalInMinutes % 60)
                    : Math.floor(totalInMinutes % 60);

            return hours + ':' + seconds;
        },
    },
    methods: {
        idealWidth(interval) {
            return ((interval.idealMinutes * 60) / this.totalDuration) * 100;
        },
    },
};
</script>
